<template>
  <div>
    <div class="d-flex align-center px-2 py-2 pb-6">
      <div>
        <v-btn
          icon
          small
          @click="goBack"
          class="mr-2"
        >
          <Icon
            :width="24"
            :icon="'arrow-left'"
          />
        </v-btn>
      </div>
      <div class="flex-fill mr-2">
      </div>
    </div>
    <div class="pa-5 py-15 text-center text--secondary">
      <div>
        No fue posible obtener la información del usuario
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'


@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  }
})
export default class Empty extends Vue {
  goBack () {
    this.$emit('goBack')
  }
}
</script>
